import { render, staticRenderFns } from "./submit_over.vue?vue&type=template&id=19ce1587&scoped=true&"
import script from "./submit_over.vue?vue&type=script&lang=js&"
export * from "./submit_over.vue?vue&type=script&lang=js&"
import style0 from "./submit_over.vue?vue&type=style&index=0&id=19ce1587&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce1587",
  null
  
)

export default component.exports